import fetch from "auth/FetchInterceptor";

const CollateralManagementService = {};

CollateralManagementService.posCollateralManagementService = function (data) {
   
  return fetch({
    url: `/Collateral/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

CollateralManagementService.putCollateralManagementService = function (data) {
  return fetch({
    url: `/Collateral/edit`,
    method: "put",
    headers: {
      "x-requestId": data?.requestId,
    },
    data: data?.data,
  });
};

CollateralManagementService.deleteCollateralManagementService = function (
  data
) {
  return fetch({
    url: `/Collateral/delete`,
    method: "delete",
    headers: {
      "x-requestId": data?.requestId,
    },
    data: data?.data,
  });
};

CollateralManagementService.approvalCollateralService = function (data) {
  // console.log('"🚀 ~ dataApproval:", data);',data?.data);

  return fetch({
    url: `/Collateral/approve`,
    method: "put",
    headers: {
      "x-requestId": data?.requestId,
    },
    data: data?.data,
  });
};

CollateralManagementService.RequestedId = function (data) {
  console.log("🚀 ~ data:", data);

  return fetch({
    url: `/Collateral/return`,
    method: "put",
    headers: {
      "x-requestId": data?.requestId,
    },
    data: data?.data,
  });
};

CollateralManagementService.deleteCollateralSlice = function (data) {
  return fetch({
    url: `/Collateral/delete`,
    method: "delete",
    headers: {
      "x-requestId": data?.requestId,
    },
    data: data?.data,
  });
};
CollateralManagementService.getCollateralManagementService = function (data) {
  console.log("🚀 ~ datagetCollateralManagementService:", data);

  const pageIndex = data.pageIndex ?? 0;
  const actualIndex = pageIndex > 0 ? pageIndex - 1 : 0;

  const params = new URLSearchParams();

  params.append("pageSize", data.pageSize ?? 10);
  params.append("pageIndex", actualIndex);

  if (data.collateralTypeId)
    params.append("collateralTypeId", data.collateralTypeId);
  if (data.pengikatanId) params.append("pengikatanId", data.pengikatanId);
  if (data.ownerName) params.append("ownerName", data.ownerName);
  if (data.documentNo) params.append("documentNo", data.documentNo);
  if (data.collateralDocId)
    params.append("collateralDocId", data.collateralDocId);

  return fetch({
    url: `/Collateral/search?${params.toString()}`,
    method: "get",
  });
};

CollateralManagementService.getCollateralManagementApprovalService = function (
  data
) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  return fetch({
    url:
      "/Collateral/approvalCollateral?pageSize=" +
      data.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&collateralTypeId=" +
      data?.collateralTypeId +
      "&pengikatanId=" +
      data?.pengikatanId +
      "&ownerName=" +
      data?.ownerName +
      "&documentNo=" +
      data?.documentNo,
    method: "get",
  });
};

CollateralManagementService.checkDuplicateService = function (data) {
  return fetch({
    url: `/Collateral/check-duplicate`,
    method: "post",
    data: data,
  });
};

export default CollateralManagementService;
